import { createBrowserHistory } from 'history'

export const routeHistory = createBrowserHistory()

export const goTo = (path: string): void => routeHistory.push(path)
